var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"mask"},[_c('div',{staticClass:"window sgl-aligncenter scalein"},[_c('SglImage',{staticClass:"sgl-aligncenter",attrs:{"src":require('@/assets/images/popup/bg.png'),"width":932,"height":1292}},[_c('div',{staticClass:"content sgl-aligncenter"},[_c('SglImage',{staticClass:"sgl-center",attrs:{"src":_vm.photoUrl,"width":416,"height":416},on:{"click":_vm.previewPhotoUrl}},[_c('div',{style:({
              position: 'absolute',
              bottom: 'calc(2 * var(--app-vw))',
              right: 'calc(2 * var(--app-vw))',
              color: '#fdf3a6',
              'background-color': '#ff863e',
              padding: 'calc(1 * var(--app-vw))',
              'border-radius': '1000px',
              'text-align': 'center',
              'font-size': '0.9rem',
            })},[_vm._v("\n            "+_vm._s(_vm.player.no < 10 ? "0" + _vm.player.no : _vm.player.no)+"\n          ")])]),_vm._v(" "),(_vm.player.name.length < 15)?_c('div',{staticClass:"line-1",style:({
            'text-align': '-webkit-center',
            width: 'calc(60 * var(--app-vw))',
            'max-width': 'calc(60 * var(--app-vw))',
            'margin-top': '0.5rem',
            position: 'relative',
            height: '1.5rem',
          })},[_c('p',{style:({
              'font-size': '1rem',
              'text-align': '-webkit-center',
              width: 'fit-content',
              'max-width': '100%',
              margin: 'calc(1 * var(--app-vw)) 0',
              'line-height': '1em',
            })},[_vm._v("\n            "+_vm._s(_vm.player.name)+"\n          ")])]):_c('div',{staticClass:"line-1",style:({
            'text-align': '-webkit-center',
            width: 'calc(60 * var(--app-vw))',
            'max-width': 'calc(60 * var(--app-vw))',
            'margin-top': '0.5rem',
            position: 'relative',
            height: '1.5rem',
          })},[_c('p',{style:({
              'font-size': '1rem',
              'text-align': '-webkit-center',
              width: 'fit-content',
              'max-width': '100%',
              margin: 'calc(1 * var(--app-vw)) 0',
              position: 'absolute',
              animation: _vm.getAnimation(),
              'line-height': '1em',
              height: '1.5rem',
            })},[_vm._v("\n            "+_vm._s(_vm.player.name)+"\n          ")])]),_vm._v(" "),(_vm.musicUrl && _vm.musicPlay)?_c('SglImage',{staticClass:"sgl-center",staticStyle:{"margin-top":"0.3rem"},attrs:{"src":require('@/assets/images/popup/music.gif'),"width":491,"height":67},on:{"click":_vm.changeMusic}}):_vm._e(),_vm._v(" "),(_vm.musicUrl && !_vm.musicPlay)?_c('SglImage',{staticClass:"sgl-center",staticStyle:{"margin-top":"0.3rem"},attrs:{"src":require('@/assets/images/popup/music.png'),"width":491,"height":67},on:{"click":_vm.changeMusic}}):_vm._e(),_vm._v(" "),(_vm.musicUrl)?_c('div',{ref:"scrollbar",style:({
            position: 'absolute',
            top: _vm.top,
            right: 'calc(10 * var(--app-vw))',
            width: 'calc(1 * var(--app-vw))',
            height: 'calc(12 * var(--app-vw))',
            'margin-top': 'calc(59 * var(--app-vw))',
            'background-color': '#bfbfbf',
            'border-radius': 'calc(1 * var(--app-vw))',
            transition: 'top 0.01s',
            'z-index': 21,
          })}):_c('div',{ref:"scrollbar",style:({
            position: 'absolute',
            top: _vm.top,
            right: 'calc(10 * var(--app-vw))',
            width: 'calc(1 * var(--app-vw))',
            height: 'calc(12 * var(--app-vw))',
            'margin-top': 'calc(51 * var(--app-vw))',
            'background-color': '#bfbfbf',
            'border-radius': 'calc(1 * var(--app-vw))',
            transition: 'top 0.01s',
            'z-index': 21,
          })}),_vm._v(" "),_c('div',{ref:"contentD",staticClass:"contentD hiddenscroll",staticStyle:{"text-align":"justify","font-size":"0.8rem","overflow-y":"auto","margin-top":"0.4rem"},style:({
            height: _vm.musicUrl
              ? 'calc(var(--app-vw) * 31)'
              : 'calc(var(--app-vw) * 39)',
            'max-height': _vm.musicUrl
              ? 'calc(var(--app-vw) * 31)'
              : 'calc(var(--app-vw) * 39)',
          }),on:{"scroll":_vm.scrollHandle}},[_vm._v("\n          "+_vm._s(_vm.player.intro)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"sgl-flex",staticStyle:{"margin-top":"0.8rem"}},[_c('SglImage',{staticStyle:{"margin-right":"2rem"},attrs:{"src":require('@/assets/images/popup/lightbtn.png'),"width":269,"height":79},on:{"click":_vm.vote}}),_vm._v(" "),_c('SglImage',{attrs:{"src":require('@/assets/images/popup/sharebtn.png'),"width":269,"height":79},on:{"click":_vm.showShareBg}})],1)],1)]),_vm._v(" "),_c('SglImage',{staticClass:"sgl-center",staticStyle:{"margin-top":"1rem"},attrs:{"src":require('@/assets/images/popup/close.png'),"width":80,"height":80},on:{"click":_vm.close}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-777568ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DetailPopupUp.vue
// module id = null
// module chunks = 